// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"main_buttonsWrapper__buN6I"};